import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShowEvents } from "../../../../context/Slice/EventManagementSlice";
import { ShowAllCoordinatorProfiles } from "../../../../context/Slice/CoordinatorManagementSlice";
import { Button } from "@mui/material";
import "./EventInquiry.css";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router";

const EventInquiry = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const allEvents = useSelector((state) => state.EventManagementR.Data);
  const [show, setShow] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedNotes, setSelectedNotes] = useState(null);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [coordinatorProfile, setCoordinatorProfile] = useState([]);

  const token = secureLocalStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const ID = decoded._id;
        dispatch(ShowEvents(ID));
      } catch (error) {
        console.error("Token decoding failed:", error);
      }
    }
  }, [dispatch, token]);

  useEffect(() => {
    // Dispatch the action to fetch coordinator profiles
    dispatch(ShowAllCoordinatorProfiles())
      .unwrap()
      .then((response) => {
        // Log the language field to the console
        if (response && response.ShowCoordinatorProfile) {
          setCoordinatorProfile(response.ShowCoordinatorProfile);
        }
      })
      .catch((error) => {
        console.error("Error fetching coordinator profiles:", error);
      });
  }, [dispatch]);

  const handleClose = () => setShow(false);
  const handleCloseNotesModal = () => setShowNotesModal(false);
  const handleShow = (event) => {
    setSelectedEvent(event);
    setShow(true);
  };

  const handleShowNotesModal = (event) => {
    if (event.Notes && Array.isArray(event.Notes)) {
      setSelectedNotes(event.Notes); // Set the notes only if it's an array
    } else {
      setSelectedNotes([]); // Set an empty array if no notes are available
    }
    setShowNotesModal(true);
  };

  console.log(coordinatorProfile);
  console.log(selectedEvent);

  const data = coordinatorProfile
    .filter((data) => selectedEvent?.Coordinator_id === data.Coordinators_ID)
    .map((cord) => cord.meeting_Slots);
  console.log(data);

  const handleAdd = () => {
    console.log("Selected Event Before Navigation:", selectedEvent);
    navigate("/co-ordinator-dashboard/Add-VendorForm", {
      state: { selectedEvent },
    });
  };

  const handleAddNote = () => {
    console.log("Selected Event Before Navigation:", selectedEvent); // Add this line
    if (selectedEvent) {
      navigate("/co-ordinator-dashboard/Add-Note", {
        state: { selectedEvent },
      });
    } else {
      console.error("No event selected to add a note for.");
    }
  };

  const convertToNumber = (budgetOption) => {
    // Helper function to convert "L" notation to actual numbers
    const lakhToNumber = (str) => Number(str.replace("L", "")) * 100000;
  
    // Helper function to extract numbers from strings (e.g., "5000-10000")
    const parseNumber = (str) => Number(str.replace(/[^0-9]/g, "")); // Remove non-numeric characters
  
    if (budgetOption.includes("-")) {
      // Case: Range like "1L-3L" or "5000-10000"
      const [minStr, maxStr] = budgetOption.split("-");
      const min = minStr.includes("L") ? lakhToNumber(minStr) : parseNumber(minStr);
      const max = maxStr.includes("L") ? lakhToNumber(maxStr) : parseNumber(maxStr);
      return { min, max, average: (min + max) / 2 };
    } else if (budgetOption.startsWith("<") || budgetOption.startsWith("Up to") || budgetOption.startsWith("Upto")) {
      // Case: "<1L", "<5000", "Upto 1L", "Upto 10000"
      const value = budgetOption.includes("L")
      ? lakhToNumber(budgetOption.replace(/<|Up to|Upto/g, "").trim()) * 0.75 // Assume 75% of the given value
      : parseNumber(budgetOption.replace(/<|Up to|Upto/g, "").trim()) * 0.75;
      return { min: value, max: value, average: value };
    } else if (budgetOption.startsWith(">")) {
      // Case: ">5L" or ">30000"
      const value = budgetOption.includes("L")
        ? lakhToNumber(budgetOption.substring(1)) * 1.2 // Assume 120% of given value
        : parseNumber(budgetOption.substring(1)) * 1.2;
      return { min: value, max: value, average: value };
    } else {
      // Case: Single value like "2L" or "10000"
      const value = budgetOption.includes("L") ? lakhToNumber(budgetOption) : parseNumber(budgetOption);
      return { min: value, max: value, average: value };
    }
  };
  
  const calculateTotalBudget = () => {
    let totalBudget = 0;
  
    if (selectedEvent && selectedEvent.Budget && selectedEvent.Budget.categories) {
      selectedEvent.Budget.categories.forEach((category) => {
        const convertedBudget = convertToNumber(category.price); // Convert category price
        totalBudget += convertedBudget.average; // Use the average budget for calculation
      });
    }
  
    return totalBudget;
  };
  
  
  const filteredEvents = allEvents.filter(
    (event) =>
      event.EventName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (event.User.firstName + " " + event.User.lastName)
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  );
  const HandleBack = () => {
    navigate("/co-ordinator-dashboard");
  };

  const handleGuestlist = (id) => {
    console.log(id)
    navigate("/co-ordinator-dashboard/Coordinator-guest-list", { state: { id } });
  };
  
  return (
    <div id="Event-inquiry">
      <div>
        <Button
          variant="contained"
          color="secondary"
          onClick={HandleBack}
          sx={{ position: "absolute", top: "20px", left: "20px" }}
        >
          Back
        </Button>
        <h2 className="heading">Events Inquiry</h2>
        <div className="searchField">
          <input
            type="text"
            placeholder="Search by Name or Event Name"
            className="searchInput"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <div className="grid">
        {filteredEvents && filteredEvents.length > 0 ? (
          filteredEvents.map((event, index) => (
            <div className="card" key={index}>
              <div className="card-body">
                <h5 className="card-title fw-bold">{event.EventName}</h5>
                <p className="card-text">
                  <strong>Name:</strong> {event.User.firstName}{" "}
                  {event.User.lastName}
                </p>
                <p className="card-text">
                  <strong>Email:</strong> {event.User.email}
                </p>
                <p className="card-text">
                  <strong>Mobile:</strong> {event.User.mobile_number}
                </p>
                <p className="card-text">
                  <strong>Notes:</strong> {event.Description}
                </p>
                <button className="btn" onClick={() => handleShow(event)}>
                  View
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>No events available.</p>
        )}
      </div>

      {show && selectedEvent && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            <div className="custom-modal-header">
              <h5 className="custom-modal-title">{selectedEvent.EventName}</h5>
            </div>
            <div className="custom-modal-body">
              <p>
                <strong>Description:</strong> {selectedEvent.Description}
              </p>
              <p>
                <strong>Proposed Date:</strong> {selectedEvent.Proposed_Date}
              </p>
              <p>
                <strong>Start Date:</strong> {selectedEvent.Start_Date}
              </p>
              <p>
                <strong>End Date:</strong> {selectedEvent.End_Date}
              </p>
              <p>
                <strong>Number of guest:</strong> {selectedEvent.Guest}
              </p>
              <div>
                <h2 className="text-center ">Categories</h2>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedEvent.Budget.categories.map((category, index) => (
                      <tr key={index}>
                        <td>{category.type}</td>
                        <td>{category.price}</td>
                      </tr>
                    ))}
                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td>
                        <strong>{calculateTotalBudget()}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <strong>Event Budget:</strong>{" "}
                {selectedEvent.Budget.eventBudget}
              </p>
              <p>
                <strong>Status:</strong> {selectedEvent.Status}
              </p>
              <p>
                <strong>User:</strong> {selectedEvent.User.firstName}{" "}
                {selectedEvent.User.lastName}
              </p>
              <p>
                <strong>Email:</strong> {selectedEvent.User.email}
              </p>
              <p>
                <strong>Other Email:</strong> {selectedEvent.email}
              </p>
              <p>
                <strong>Mobile:</strong> {selectedEvent.User.mobile_number}
              </p>
              <p>
                <strong>Other Mobile:</strong> {selectedEvent.mobile_number}
              </p>
              {selectedEvent.Coordinator_id && (
                <div style={{ marginTop: "20px", padding: "15px" }}>
                  <h2 style={{ textAlign: "center", marginBottom: "15px" }}>
                    <i className="fas fa-calendar-alt"></i> Meetings
                  </h2>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {coordinatorProfile
                      .filter(
                        (data) =>
                          selectedEvent.Coordinator_id === data.Coordinators_ID
                      )
                      .flatMap((cord) =>
                        cord.meeting_Slots.length > 0 ? (
                          cord.meeting_Slots.map((slot, index) => (
                            <div
                              key={index}
                              style={{
                                background: "#f8f9fa",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRadius: "5px",
                                fontSize: "16px",
                                fontFamily: "Arial, sans-serif",
                              }}
                            >
                              <strong style={{ color: "#28a745" }}>
                                <i className="fas fa-clock"></i> Meeting{" "}
                                {index + 1}
                              </strong>
                              <br />
                              <span style={{ color: "#555" }}>
                                🕒 <strong>Start:</strong>{" "}
                                {new Date(slot.start).toLocaleString("en-IN", {
                                  timeZone: "Asia/Kolkata",
                                })}
                              </span>
                              <br />
                              <span style={{ color: "#555" }}>
                                🕒 <strong>End:</strong>{" "}
                                {new Date(slot.end).toLocaleString("en-IN", {
                                  timeZone: "Asia/Kolkata",
                                })}
                              </span>
                            </div>
                          ))
                        ) : (
                          <div
                            key="no-meetings"
                            style={{
                              background: "#ffebcc",
                              padding: "10px",
                              border: "1px solid #ffb74d",
                              borderRadius: "5px",
                              textAlign: "center",
                              fontWeight: "bold",
                              color: "#d35400",
                            }}
                          >
                            <i className="fas fa-exclamation-circle"></i> No
                            meetings available
                          </div>
                        )
                      )}
                  </div>
                </div>
              )}

              <div>
                <h2 className="text-center mt-4">Event Notes</h2>
                {selectedEvent.Event_Notes &&
                selectedEvent.Event_Notes.length > 0 ? (
                  <div className="notes-section">
                    {selectedEvent.Event_Notes.map((note, index) => (
                      <div key={index} className="note">
                        <h6 className="note-title">
                          <strong>
                            {index + 1}. {note.title}
                          </strong>
                        </h6>
                        <p className="note-text">
                          <em>{note.note}</em>
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No notes available for this event.</p>
                )}
              </div>

              {/* Vendors Table */}
              {selectedEvent.Event_Vendors &&
                selectedEvent.Event_Vendors.length > 0 && (
                  <div>
                    <h2 className="text-center mt-4">Event Vendors</h2>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Vendor No</th>
                          <th>Service Name</th>
                          <th>Price Range</th>
                          {/* <th>End Price Range</th> */}
                          <th>Address</th>
                          <th>City</th>
                          <th>Category</th>
                          <th>Email</th>
                          <th>Mobile Number</th>
                          <th>Whatsapp Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedEvent.Event_Vendors.map((vendor, index) => (
                          <tr key={index}>
                            <td>{vendor.VendorNo}</td>
                            <td>{vendor.serviceName}</td>
                            <td>{vendor.startPriceRange}</td>
                            {/* <td>{vendor.endPriceRange}</td> */}
                            <td>{vendor.address}</td>
                            <td>{vendor.city}</td>
                            <td>{vendor.category}</td>
                            <td>{vendor.email}</td>
                            <td>{vendor.mobileNumber}</td>
                            <td>{vendor.whatsappNumber}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
            </div>
            <div className="custom-modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleAdd}
              >
                Add Vendors
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleAddNote}
              >
                Add Note
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => handleGuestlist(selectedEvent.User_id)}
                >
                Show Guest List{" "}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Notes Modal */}
      {showNotesModal && Array.isArray(selectedNotes) && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            <div className="custom-modal-header">
              <h5 className="custom-modal-title">Event Notes</h5>
            </div>
            <div className="custom-modal-body">
              {selectedNotes.length > 0 ? (
                selectedNotes.map((note, index) => (
                  <div key={index}>
                    <h6>{note.title}</h6>
                    <p>{note.note}</p>
                  </div>
                ))
              ) : (
                <p>No notes available.</p>
              )}
            </div>
            <div className="custom-modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseNotesModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventInquiry;
